// ─── Chaves de storage ────────────────────────────────────────────────────────

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
} as const;

// ─── Tokens internos ──────────────────────────────────────────────────────────

export interface AuthTokens {
  accessToken: string;
  refreshToken?: string | null;
}

// ─── Requests ─────────────────────────────────────────────────────────────────

export interface LoginRequest {
  email: string;
}

export interface VerificationCodeRequest {
  codigo: string;
}

export interface RefreshTokenRequest {
  refresh_token: string;
}

// ─── Responses ────────────────────────────────────────────────────────────────

export interface LoginResponse {
  message?: string;
}

export interface RefreshTokenResponse {
  access_token: string;
  /** Presente quando o SGI usa refresh token rotation */
  refresh_token?: string;
  token_type?: string;
}

/** API pode devolver snake_case ou camelCase — normalizar em AuthService.handleCallback */
export interface CallbackResponse {
  access_token?: string;
  refresh_token?: string;
  accessToken?: string;
  refreshToken?: string;
  token_type?: string;
}

// ─── Usuário ──────────────────────────────────────────────────────────────────

export interface UsuarioRead {
  id: string;
  nome: string;
  cpf: string;
  email: string;
  administrador: boolean;
  ativo: boolean;
  data_criacao: string;
  data_atualizacao: string;
}